module.exports = __webpack_public_path__ + "static/media/category7.c2921624.png";